import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  // Bearer token (localStorage) is the primary auth path. Cookies are
  // redundant and cause CORS "Network Error" on production where the
  // ingress sets `Access-Control-Allow-Origin: *` together with
  // `Access-Control-Allow-Credentials: true` — invalid per the spec
  // when the request opts into credentials. Disabling withCredentials
  // tells the browser this isn't a credentials-mode request, so the
  // wildcard origin becomes acceptable.
  withCredentials: false,
});

// Attach bearer token from localStorage as fallback for CORS-free auth
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("scanmint_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("scanmint_token", token);
  else localStorage.removeItem("scanmint_token");
}

export function formatApiError(err) {
  // Network/CORS failures: axios sets err.message="Network Error" with no response.
  if (err && !err.response) {
    return "Network error — check your internet connection and try again.";
  }
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
